import microuniversoApi from "app/api/microuniversoApi"
import { atualizarItemAction, sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import { IOrcamento } from "app/types/IOrcamento"
import {CriaOrcamentoAposTotalizador} from "../../utils/CriaOrcamentoAposTotalizador";
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'



declare var window:any

export type definirValorDescontoInput = {
    valorDesconto: number
}

export async function definirValorDesconto(input: definirValorDescontoInput) {

    const orcamentoAtualizado = await microuniversoApi.Orcamento.DefinirValorDesconto(
        store.getState().orcamento.IdentificadorOrcamento,
        input.valorDesconto
    )

    const atualizarEstado = () => {// 489400
        const orcamentoLegado = window.orcamentoController.model

        orcamentoLegado.atualizar(orcamentoAtualizado, true, true)
''
        store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(orcamentoAtualizado))// 489400
    }


    const atualizarOrcamentoLegadoERedux = () => {
        const orcamentoAtual = store.getState().orcamento
        const orcamentoLegado = window.orcamentoController.model
        const novosOrcamentos = CriaOrcamentoAposTotalizador(orcamentoAtual, orcamentoLegado, orcamentoAtualizado)

        orcamentoLegado.atualizar(novosOrcamentos.orcamentoLegado)

        store.dispatch(sobrescreverInformacoesAction(novosOrcamentos.orcamentoReact))

    }

    atualizarEstado() // 489400
    atualizarOrcamentoLegadoERedux()
}
